export const formSessionStorageKey = 'lasuite:register-form';
